<template>
  <tg-dialog
    ref="dialog"
    v-bind="{ ...$attrs }"
    v-on="$listeners"
    :showFooter="false"
    :showCancelBtn="false"
    class="history-reward-info"
    width="70%"
    append-to-body
    :visible.sync="visible"
    :showIcon="false"
    @opened="handleOpen"
  >
    <template slot="title">
      {{ title }}
    </template>

    <el-container direction="vertical" class="info--container">
      <template v-for="(item, index) in items">
        <el-row :key="index" type="flex" justify="start" class="info-row">
          <el-col :span="6" class="info-row--column">
            <span>
              {{ $t("component.label.source_type." + item.source_type) }}
            </span>
            <template v-if="!item.isReal">
              <span>({{$t("enum.half")}})</span>
            </template>
          </el-col>
          <el-col :span="12" class="info-row--value">
            <el-row type="flex" justify="start" class="el-col-24">
              <span style="width: 45%">
                {{ reward_column }}:<span class="text-info ma-l-2">{{
                  item.reward | decimal
                }}</span>
              </span>
              <span class="ma-l-3">
                {{ num_column }}:<span class="text-info ma-l-2">
                  {{ item.num }}</span
                >
              </span>
            </el-row>
          </el-col>
          <el-col :span="6" class="info-row--action">
            <tg-button
              round
              :classes="['tg-btn--search']"
              :disabled="item.reward <= 0"
              @click.native="handleClick(item)"
            >
              {{ $t("column.detail") }}
            </tg-button>
          </el-col>
        </el-row>
      </template>
    </el-container>
  </tg-dialog>
</template>

<script>
// import TgLayout from "@/layout/TgLayout";
// import TgTable from "@/components/table/TgTable";
import TgButton from "@/components/button/TgButton";
import TgDialog from "@/components/dialog/TgDialog.vue";
import formatter from "@/utils/formatter";
import apis from "@/apis";
const api = apis.accounts.reward_info;

export default {
  inheritAttrs: false,
  components: {
    // TgLayout,
    // TgTable,
    TgButton,
    TgDialog,
  },
  // provide() {
  //   return {
  //     container: this.$el,
  //   };
  // },
  data() {
    return {
      columns: [],
      proxy: api.getData,
      searchData: {},
      visible: false,
      items: [],
      isReal: {}
    };
  },
  props: {
    rewardInfo: Object,
  },
  computed: {
    title() {
      return this.rewardInfo ? this.rewardInfo.title : "";
    },
    reward_column() {
      return this.title ? this.title.split(" - ")[1] : "";
    },
    num_column() {
      return this.$t("column.num");
    },
  },
  created() {
    api.getColumns().then((response) => {
      this.columns = response.data;
    });
  },
  filters: {
    decimal(value) {
      return formatter.format(value, "decimal:2");
    },
  },
  methods: {
    handleOpen() {
      this.proxy(this.rewardInfo).then((response) => {
        this.items = response.data;
        response.data.forEach(item => {
          this.isReal[item.source_type] = item.isReal;
        });
      });
      // this.$refs.table.init(this.rewardInfo);
    },
    showDialog() {
      this.visible = true;
    },
    handleClick(row) {
      this.rewardInfo.source_type = row.source_type;
      this.rewardInfo.isReal = this.isReal;
      this.visible = false;
      this.$emit("on-click", this.rewardInfo);
    },
  },
};
</script>
